import React from 'react';
import PageHeader from '../Shared/PageHeader';

const Cart = () => {
    return (
        <div>
            <PageHeader title="Your Cart"></PageHeader>
            <div className="main-wrapper">
                <div className="shopping_cart dark_cart">
                    <div className="container">
                        <table className="cart_table">
                            <tr className="cart_header">
                                <th className="cart_header_removal"></th>
                                <th className="cart_header_title">Product</th>
                                <th className="cart_header_price">Price</th>
                                <th className="cart_header_quantity">Quantity</th>
                                <th className="cart_header_total">Total</th>
                            </tr>
                            <tr className="cart_content">
                                <td className="cart_removal"><i className="ion-ios-close-empty"></i></td>
                                <td className="cart_title"><span className="cart_image"><img src="images/cart/1.jpg" alt="" /></span> Wooden Table Top</td>
                                <td className="cart_price">$ 210</td>
                                <td className="cart_quantity"><input type="number" value="1" min="1" /></td>
                                <td className="cart_total">$ 210</td>
                            </tr>
                            <tr className="cart_content">
                                <td className="cart_removal"><i className="ion-ios-close-empty"></i></td>
                                <td className="cart_title"><span className="cart_image"><img src="images/cart/2.jpg" alt="" /></span> Chocolate Cake</td>
                                <td className="cart_price">$ 180</td>
                                <td className="cart_quantity"><input type="number" value="2" min="1" /></td>
                                <td className="cart_total">$ 180</td>
                            </tr>
                            <tr className="cart_content">
                                <td className="cart_removal"><i className="ion-ios-close-empty"></i></td>
                                <td className="cart_title"><span className="cart_image"><img src="images/cart/3.jpg" alt="" /></span> Chocolate Cream-Pie</td>
                                <td className="cart_price">$ 110</td>
                                <td className="cart_quantity"><input type="number" value="2" min="1" /></td>
                                <td className="cart_total">$ 110</td>
                            </tr>
                            <tr className="cart_content">
                                <td className="cart_removal"><i className="ion-ios-close-empty"></i></td>
                                <td className="cart_title"><span className="cart_image"><img src="images/cart/4.jpg" alt="" /></span> Choco Pudding</td>
                                <td className="cart_price">$ 150</td>
                                <td className="cart_quantity"><input type="number" value="2" min="1" /></td>
                                <td className="cart_total">$ 150</td>
                            </tr>
                            <tr className="cart_content">
                                <td className="cart_removal"><i className="ion-ios-close-empty"></i></td>
                                <td className="cart_title"><span className="cart_image"><img src="images/cart/5.jpg" alt="" /></span> Orange Pancake</td>
                                <td className="cart_price">$ 130</td>
                                <td className="cart_quantity"><input type="number" value="2" min="1" /></td>
                                <td className="cart_total">$ 130</td>
                            </tr>
                            <tr className="cart_content">
                                <td className="cart_removal"><i className="ion-ios-close-empty"></i></td>
                                <td className="cart_title"><span className="cart_image"><img src="images/cart/6.jpg" alt="" /></span> Cream Filled Chocolate Cake</td>
                                <td className="cart_price">$ 154</td>
                                <td className="cart_quantity"><input type="number" value="2" min="1" /></td>
                                <td className="cart_total">$ 154</td>
                            </tr>
                        </table>
                        <div className="couponcart">
                            <form className="couponform" action="coupon.php" method="POST">
                                <div className="form-group">
                                    <input type="text" className="form-control" name="coupon" placeholder="Coupon Code" />
                                </div>
                                <div className="button_group">
                                    <input className="button" type="submit" value="Apply Coupon" name="submit" />
                                </div>
                            </form>
                            <div className="cartupdate">
                                <div className="button_group">
                                    <input className="button" type="submit" value="Update Cart" name="submit" />
                                </div>
                            </div>
                        </div>
                        <div className="cart_grand_total">
                            <h3 className="grand_title">Cart Total</h3>
                            <ul>
                                <li><span className="cost_per">Subtotal</span> <span className="value">$1500</span></li>
                                <li><span className="cost_per">Tax (10%)</span> <span className="value">$150</span></li>
                                <li><span className="cost_per">Shipping</span> <span className="value">$50</span></li>
                                <li className="totalvalue"><span className="cost_per">Total</span> <span className="value">$1700</span></li>
                            </ul>
                            <div className="button_group">
                                <input className="button" type="submit" value="Proceed To Checkout" name="submit" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cart;